import { ReactNode } from 'react'
import Header from './layout/Header'
import Footer from './layout/Footer'
import MigrationBanner from './general/MigrationBanner'
import PlanModal from './premium/PlanModal'
import LoginModal from './login/LoginModal'
import { useAppDependencies } from '../context/AppContext'

interface LayoutProps {
  children: ReactNode
}

/**
 * Shared layout component that includes Header and Footer.
 * Used by React Router routes to maintain consistent page structure.
 */
export default function Layout({ children }: LayoutProps) {
  const dependencies = useAppDependencies()
  
  return (
    <div>
      <MigrationBanner />
      <div className="body">
        <Header
          pathRouter={dependencies.pathRouter}
          apiHandler={dependencies.apiHandler}
          stateHandler={dependencies.stateHandler}
          loginHelper={dependencies.loginHelper}
          featureProvider={dependencies.featureProvider}
        />
        {children}
      </div>
      <Footer />
      <PlanModal stateHandler={dependencies.stateHandler} apiHandler={dependencies.apiHandler} />
      <LoginModal stateHandler={dependencies.stateHandler} loginHelper={dependencies.loginHelper} apiHandler={dependencies.apiHandler} />
    </div>
  )
}


